(function () {
  'use strict';

  d3.chart('ChartBase').extend('BarChartWithoutLabel', {
    initialize : function () {
      var plot = this;

      plot.layers = {
        bars : plot.wrap.append('g').classed('bars', true)
      };

      plot.bucket = d3.scale.ordinal();
      plot.value = d3.scale.linear();

      function getElemShape(elem){
        var bbox = {};
        try {
          bbox = elem.getBBox();
        } catch(e) {
          // Firefox 3.0.x plays badly here
        } finally {
          bbox = bbox || {};
        }
        return bbox;
      }

      // We wrap the original datum in an array with its rank.
      // This augments the given function to just get the datum
      function origDatum(fn) {
        return function (datumRankPair, i, j, k) {
          return fn.call(this, datumRankPair[0], i, j, k);
        };
      }

      plot.layer('bars', plot.layers.bars, {
        dataBind : function (data) {
          return this.selectAll('.bucket')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('bucket', true);
          group.append('rect').classed('bar-bg', true);
          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var bucket = this;

            function lengthFn(item, barIndex) {
              var barValue = parseFloat(plot.fn.valueLabel[barIndex](item));
              if(barValue === 100) barValue = 97;
              var bgBarWidth = plot.value.range()[1];
              var barWidth = (barValue*bgBarWidth)/100;
              return barWidth;
            }

            bucket.select('.bar-bg')
                .attr('height', plot.bucket.rangeBand())
                .attr('width', plot.value.range()[1])
                .translate(0, 0)
                .classed('even',true)
                .attr('stroke-dasharray', '2,2');

            var group = bucket.selectAll('.bar-group')
                .data(d3.range(plot.fn.value.length));

            group.exit().remove();

            // augment group functions to give you the original datum
            function parentDatum(fn) {
              return function (index, __, j) {
                return origDatum(fn).call(this, plot.data.page[j], index, j);
              };
            }

            group.translate(parentDatum(function (item, index) {
              var translation = d3.sum(d3.range(index), function (prevBarIndex) {
                return lengthFn(item, prevBarIndex);
              });
              return [translation, 0];
            }));

            var newGroups = group.enter()
                .append('g').classed('bar-group', true);
            newGroups.append('rect').classed('bar', true);
            newGroups.append('text').classed('bar-value', true)
                .attr('alignment-baseline', 'middle')
                .attr('text-anchor', 'start');

            group.select('.bar')
                .attr('height', plot.bucket.rangeBand())
                .transition()
                .duration(750)
                .attr('width', parentDatum(lengthFn))
                .attr('fill', function (d, i) {
                  return plot.fn.color[i];
                });

            function putLabel(elem, barLength, anchorAttr, outsideAnchor, insideAnchor) {
              var labelPadding = 20;
              // Get the size of the value label in the direction of the bars
              var valueSize = getElemShape(elem)['width'];
              // We'll put the label outside the bar if there isn't enough padding
              var putOutside = barLength - valueSize < labelPadding;
              // The position is calculated from the 'base' of the bar -- this gets inverted for vertical bars
              var position = barLength + (putOutside ? 1 : -1) * labelPadding;
              d3.select(elem)
              // Set the anchor point of label on the appropriate edge
                  .attr(anchorAttr, putOutside ? outsideAnchor : insideAnchor)
                  // Change the text color if it's outside the bar so it's visible
                  .classed('outside-bar', putOutside);
              return position;
            }

            group.select('.bar-value').text(parentDatum(function (item, index) {
              return plot.fn.valueLabel[index](item);
            }))
                .attr('x', parentDatum(function (item, index) {
                  return putLabel(this, lengthFn(item, index), 'text-anchor', 'start', 'end');
                }))
                .attr('y', plot.bucket.rangeBand()/2);
          }
        }
      });

      function calcRange() {
        plot.bucket.rangeRoundBands([0, plot.h], 0, 0);
        plot.value.range([0, Math.max(plot.w, 0)]);
        plot.layers.bars.translate(0, 0);
      }

      plot.on('change:width', calcRange)
          .on('change:height', calcRange)
          .on('change:data', calcRange);
    },
    valuesArray : function (item) {
      return this.fn.value.map(function (fn) {
        return fn(item);
      });
    },
    transform : function (data) {
      var plot = this;

      if (data !== plot.data) {
        _.defaults(data, {
          fn : {},
          pageSize : data.data.length,
          currentPage : 1
        });
        plot.fn = _.defaults(data.fn, {
          value : _.property('value'),
          color : ["#7C0A40"],
        });
        _.defaults(data.fn, {
          valueLabel : data.fn.valueLabel
        });
        if (!_.isArray(plot.fn.value)) {
          plot.fn.value = [plot.fn.value];
        }
        if (!_.isArray(plot.fn.valueLabel)) {
          plot.fn.valueLabel = [plot.fn.valueLabel];
        }
        if(!_.isArray(plot.fn.color)){
          plot.fn.color = [plot.fn.color];
        }

        // developer errors
        if (plot.fn.value.length > 1) {
          if (!_.isArray(plot.fn.stackLabel) || plot.fn.stackLabel.length !== plot.fn.value.length) {
            throw new Error('plot.fn.value has more than 1 function yet plot.fn.stackLabel is not an array of the same length');
          }
          if (plot.fn.valueLabel.length !== plot.fn.value.length) {
            throw new Error('plot.fn.value has more a different number of functions than plot.fn.valueLabel');
          }
        }

        var sumOfAllValues = function (item) {
          return _.sum(plot.valuesArray(item));
        };

        var range = data.fn.brandDataRange ? data.fn.brandDataRange(data.data):d3.max(data.data, sumOfAllValues);
        plot.value.domain([0, range]);

        // setup a lazily evaluated chain of transformations
        var dataChain = _(data.data);

        // Only order if we want the rank numbers
        if (!data.dontRank) {
          dataChain = dataChain.orderBy(sumOfAllValues, ['desc']);
        }

        // Hold onto the original ranking number, or else it'd be erased when filtering or paging
        dataChain = dataChain.map(function (d, i) {
          return [d, i + 1];
        });

        // Finally evaluate the chain of transformations above to a concrete values
        data.data = dataChain.value();

        data.page = data.data;

        plot.bucket.domain(d3.range(data.page.length));

        plot.data = data;
      }

      return data;
    }
  });

})();